import React from "react";
import jwt_decode from "jwt-decode";
import { Link, useLocation } from "react-router-dom";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import CardResetPassword from "../../components/cards/card.resetPassword";
import CardResetPasswordErrorToken from "../../components/cards/card.resetPasswordErrorToken";
import "../../stylesheets/passwordReset.css";

const isResetTokenValid = (token) => {
  if (!token) return false;
  try {
    const { exp } = jwt_decode(token);
    return typeof exp === "number" && exp * 1000 > Date.now();
  } catch {
    return false;
  }
};

function ForgotPassword() {
  const { search } = useLocation();
  const token = new URLSearchParams(search).get("token");
  const isValid = isResetTokenValid(token);

  return (
    <main className="password-reset-page">
      <div className="password-reset-content">
        <Link className="password-reset-back" to="/login">
          <ArrowBackOutlinedIcon fontSize="small" aria-hidden="true" />
          Retour à la connexion
        </Link>
        <section className="password-reset-card" aria-labelledby="password-reset-title">
          <h1 id="password-reset-title">{isValid ? "Réinitialisation du mot de passe" : "Lien de réinitialisation invalide"}</h1>
          {isValid ? <CardResetPassword key={token} /> : <CardResetPasswordErrorToken />}
        </section>
        <footer className="password-reset-support">
          <p>Pour plus d’informations, contactez-nous:</p>
          <div>
            <a href="mailto:support@langloys.com">support@langloys.com</a>
            <span aria-hidden="true">·</span>
            <a href="tel:+33491251338">04 91 25 13 38</a>
          </div>
        </footer>
      </div>
    </main>
  );
}

export default ForgotPassword;
